const Spinner = () => {
    return (
        <div style={{ width: '100%', minHeight: '400px' }} className="d-flex align-items-center justify-content-center mt-2">
            <div className="loader"></div>
        </div>
        // <div style={{ width: '100%' }} className="d-flex align-items-center justify-content-center mt-2">
        //     <div className="loader-box">
        //         <div className="loader-2"></div>
        //     </div>
        // </div>
    )
}

export default Spinner